import { CloseButton } from "@/components/General/Flyout/components/closeButton";
import { Content } from "@/components/General/Flyout/components/content";
import { Controls as BaseControls } from "@/components/General/Flyout/components/controls";
import { Base } from "@/components/General/Flyout/flyout.base";

const Controls = Object.assign(BaseControls, {
    CloseButton: CloseButton
});

export const Flyout = Object.assign(Base, {
    Content: Content,
    Controls: Controls
});
